import type { FC, SVGProps } from "react";

const IconWebsite: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M6.45833 12.2917C9.68 12.2917 12.2917 9.68 12.2917 6.45833C12.2917 3.23667 9.68 0.625 6.45833 0.625C3.23667 0.625 0.625 3.23667 0.625 6.45833C0.625 9.68 3.23667 12.2917 6.45833 12.2917Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.45833 0.625C4.96047 2.19776 4.125 4.28643 4.125 6.45833C4.125 8.63024 4.96047 10.7189 6.45833 12.2917C7.9562 10.7189 8.79167 8.63024 8.79167 6.45833C8.79167 4.28643 7.9562 2.19776 6.45833 0.625Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M0.625 6.45703H12.2917" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconWebsite;
